// API for testing or Development

const browserDomain = window.location.origin;

let API_Root;

if (browserDomain.includes("localhost")){
    API_Root = "https://zeta-api.essolutions.ai/";
}
else if(browserDomain.includes("alpha")){
    API_Root = "https://zeta-api.essolutions.ai/"
}
else{
    //API_Root = "http://almasi-backend-env.eba-p5n7gdhb.us-east-1.elasticbeanstalk.com/";
    API_Root = "https://api.essolutions.ai/";
}

export default API_Root